import { render, staticRenderFns } from "./NewsBW2026TokyoENG.vue?vue&type=template&id=4179870e&scoped=true&"
import script from "./NewsBW2026TokyoENG.vue?vue&type=script&lang=js&"
export * from "./NewsBW2026TokyoENG.vue?vue&type=script&lang=js&"
import style0 from "./NewsBW2026TokyoENG.vue?vue&type=style&index=0&id=4179870e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179870e",
  null
  
)

export default component.exports